import { middlewares as getUserMiddlewares } from './getUser';

export const middlewares = [...getUserMiddlewares];
